import { configureStore, Middleware, Dispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { createLogger } from 'redux-logger';
import { rootReducer } from './reducers';
import {
  persistStore,
  Persistor,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { UiStage } from '@xbcb/ui-types';
import { getEnv } from '@xbcb/ui-utils';

declare global {
  interface Window {
    dispatch: Dispatch;
    Intercom?: any;
  }
}

export let store: ReturnType<typeof configureStore>;
export let persistor: Persistor;

export const customCreateStore = () => {
  const { stage } = getEnv();

  const logMiddleWare = createLogger({
    predicate: (getState, action) => {
      if (
        action.type.startsWith('FETCH_') ||
        action.type.startsWith('@@router/') ||
        action.type.endsWith('_LOADING')
      ) {
        return false;
      } else {
        return true;
      }
    },
    collapsed: true,
  }) as Middleware;

  const middleware: Middleware[] = [];

  if (stage !== UiStage.PROD) {
    middleware.push(logMiddleWare);
  }

  store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(middleware),
    devTools:
      stage !== UiStage.PROD
        ? {
            name: 'INLT',
            maxAge: 10,
            latency: 500,
          }
        : false,
  });

  persistor = persistStore(store);
  return store;
};

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default customCreateStore;
